<template>
  <div>
    <div class="question-wrap">
      <ul>
<!--        <li v-for="(item,index) in menuList" :key="index" :data-index="index" class="question-item" v-on:click="handlerMenuClick"><span type="button">{{ item.text }}</span></li>-->
        <button v-for="(item,index) in menuList" :key="index" :data-index="index" class="question-item" v-on:click="handlerMenuClick"><span type="button">{{ item.text }}</span></button>
      </ul>
    </div>
    <div class="question-list">
      <h2 class="blind">{{tabTitle}}</h2>
      <ul>
        <li v-for="(item, index) in dataList" :key="index">
          <div v-on:click="handlerAccordino" :data-index="index">
            <a>
              <div>
                <em class="icon-qmark" aria-label="질문"></em>
                <h3 class="ellipsis-1">{{ item.title }}</h3>
              </div>
            </a>
            <button class="icon-small-bottom-arrow"></button>
          </div>
          <div class="gray-text-wrap">
            <p>{{ item.desc }}<span v-if="item.subDesc" v-for="(subItem, index) in item.subDesc" :key="index">{{ subItem }}</span></p>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'emarticonQuestions',
  data() {
    return {
      menuList: [
        { text: "사용 방법" },
        { text: "결제" },
        { text: "충전" },
        { text: "발송" },
        { text: "취소 환불" },
      ],
      dataList: [],
      useList: [
        {
          title:"Q1) 이마트페이 결제 시 이마티콘을 사용할 수 있나요?",
          desc:`A1) 네, 이마트페이로 결제하면 이마티콘 보관함에 보유하신 이마티콘을 최대 10개까지 함께 사용하실 수 있습니다.\n
          ※ 이마티콘 사용 순서 : 잔액관리형 > 유효기간 짧은 이마티콘 > 대표카드로 설정한 이마티콘 > 잔액 낮은순
          ※ 이마트앱이 아닌 타채널을 통해 구매하신 이마티콘은 이마트페이 사용이 불가합니다.`
        },
        {
          title:"Q2) 이마티콘 구매(선물) 내역은 어디서 확인하나요?",
          desc:`A2) 이마티콘 구매(선물) 내역은 [이마트앱 > 이마티콘 > 주문내역] 에서 확인하실 수 있습니다.
          이용자의 고의 또는 과실로 이마티콘 보낸 내역 또는 받은 내역이 노출되어 발생하는 손해에 대해서는 이용자 본인에게 책임이 있으며, 이마트에서 책임지지 않으니 이용에 주의하시기 바랍니다.`
        },
        {
          title:"Q3) 이마티콘 이미지(또는 쿠폰번호)를 제3자에게 전달받았습니다. 쿠폰 사용 여부를 알 수 있을까요?",
          desc:"A3) 이마티콘에서 제공하는 선물하기 서비스를 통해 수신된 쿠폰이 아닌 다른 경로(캡처본 또는 이미지로 전달 받은 쿠폰)로 전달 받은 이마티콘(혹은 바코드)의 경우, 사용 여부 및 그 외 사용 내역에 대해 정확한 확인 및 안내가 불가합니다. (고객정보보호에 의거)"
        },
        {
          title:"Q4) 유효기간이 만료된 이마티콘은 기간 연장이 불가한가요?",
          desc:`A4) 충전형 이마티콘은 별도 유효기간이 존재 하지 않습니다.
          기간에 관계없이 편리하게 사용하세요`
        },
        {
          title:"Q5) 이마티콘은 어떻게 사용하나요?",
          desc: `A5 ) 이마트앱의 이마티콘 보관함 또는 문자로 수신한 이마티콘은 이마트, 트레이더스, 에브리데이 및 전문점(노브랜드, 일렉트로마트 등)에서 사용할수 있습니다.\n
          ※불가매장 : 이마트 안양점,부천점, 일부 에브리데이 가맹점, 노브랜드 가맹점, 임대매장(푸드코트 등 일부매장 제외)
          쇼핑 후 계산하실 때 계산대에서 해당 바코드를 제시해주세요
          이마트페이로 결제시, 이마티콘 보관함에 보유한 이마티콘을 최대 10개까지 사용 가능합니다.`
        },
        {
          title:"Q6) 이마티콘은 어디서 구매할 수 있나요?",
          desc:`A6) 이마티콘은 이마트앱에서 구매 및 선물 가능합니다.
          [이마트앱 > 이마티콘]에서 확인하실 수 있습니다.`
        },
        {
          title:"Q7) 이마티콘 이용 약관에 동의해야만 서비스 이용이 가능한가요?",
          desc:"A7) 네, 이마티콘 이용 약관에 동의하셔야만 구매(선물) 및 사용이 가능합니다."
        },
        {
          title:"Q8) 이마티콘 전용 고객센터 이용시간이 어떻게 되나요?",
          desc:`A8) 이마티콘 고객센터 연락처: 02-380-5030 (운영시간: 평일 09:00~17:00)\n
              ※ 12시~13시 점심시간 및 공휴일 제외`
        },
      ],
      payList: [
        {
          title:"Q1) 결제 내역은 어디서 확인하나요?",
          desc: "A1) [이마트앱 > 이마티콘 > 주문내역]에서 확인하실 수 있으며, 결제 시 사용하신 카드사 홈페이지 또는 결제대행 PG사[TOSS페이먼츠 TEL : 1544-7772] 홈페이지를 통해서도 확인하실 수 있습니다."
        },
        {
          title: "Q2) 사용 가능한 신용카드는 어떤 건가요?",
          desc: "A2) 사용 가능한 카드는 결제대행사[TOSS페이먼츠]의 정책에 따릅니다."
        },
        {
          title: "Q3) 사용 가능한 결제 수단에는 어떤 것들이 있나요?",
          desc: "A3) 이마티콘은 신용카드(간편결제 포함)  및 계좌이체를 통해 구매하실수 있습니다."
        },
      ],
      chargingList: [
        {
          title:"Q1) 이마티콘 충전은 어떻게 하나요",
          desc: "A1) 충전 하시려는 이마티콘 선택후 일반 충전/ 정기 충전 하실수있습니다.정기 충전은 [기준하한충전/ 월 정액 자동 충전] 두가지가 있으며 자유롭게 선택 및 취소가 가능합니다."
        },
        {
          title: "Q2) 자동 충전 취소는 어떻게 해야 하나요",
          desc: "A2) 이마트앱 → 이마티콘 → 카드 보관함에서 취소 카드 선택 및 자동 충전 설정 선택후 화면 하단의 해지하기/변경하기를 통해 취소 및 변경이 가능합니다"
        },
        {
          title: "Q3) 사용 가능한 결제 수단에는 어떤 것들이 있나요?",
          desc: "A3) 이마티콘은 신용카드, 간편결제(쓱페이, 토스페이등) 및 간편 계좌 이체를 통해 구매 하실수 있습니다."
        },
      ],
      sendList: [
        {
          title:"Q1) 이마티콘을 선물 했는데 MMS가 오지 않습니다.",
          desc: `A1) 이마티콘 고객센터(02-380-5030)로 문의해 주시기 바랍니다. 이마티콘을 구매하신 고객님의 경우, 이마트앱을 통해서 확인하실 수 있습니다.
          [이마트앱 > 이마티콘 > 보관함]에서 확인 가능.`
        },
        {
          title:"Q2) 휴대폰 번호를 잘못 입력했습니다. 어떻게 처리되나요?",
          desc: `A2) 휴대폰 번호를 잘못 입력하여 발생한 발송실패 및 오발송에 대한 책임은 고객에게 있습니다. 입력 시 MMS를 받을 번호가 정확한 번호인지 다시 한번 확인 부탁드립니다. 단, 이마티콘이 사용되기 전에 고객센터를 통해 오발송 정정 신청을 한다면 수신자를 정정하여 발송할 수 있습니다. (이마티콘 고객센터 :02-380-5030)`
        },
        {
          title:"Q3) 구매(선물)한 이마티콘은 어디서 확인할 수 있나요?",
          desc: `A3) 구매하기 서비스를 통해 구매하신 이마티콘의 경우 [이마트앱 > 이마티콘 >카드 보관함]에서 확인하실 수 있습니다. 선물하기 서비스를 통해 구매하신 경우, 수신자 분에게 MMS로 발송해 드립니다.`
        },
      ],
      cancelList: [
        {
          title:"Q1) 구매/선물 받은 이마티콘을 환불 받을 수 있나요?",
          desc: "A1) 이마트앱에서 제공을 통해 수신된 쿠폰의 경우, 아래의 환불 정책을 따릅니다",
          subDesc: [
            "- 유효기간 이내 사용 가능한 이마티콘은 액면가 기준 60% 이상 사용 시, 남은 잔액의 100%에 대하여 환불 요청 가능합니다.",
            "- 할인 판매된 이마티콘의 경우, 구매금액을 기준으로 사용 비율을 계산하여 잔액을 산정합니다.",
            "- 경품 또는 사은품의 목적으로 제공된 이마티콘의 경우 환불이 불가합니다.",
            "- 구매 또는 선물받으신 이마티콘 환불 신청시 본인확인 등을 위해 증빙서류를 요구할 수 있습니다.",
            "- 본인 확인이 이루어지지 않을 경우, 환불이 불가할 수 있습니다.",
            "- 환불은 이마트APP또는  이마트 고객센터(02-380-5030)를 통하여 신청할 수 있습니다. 다만, 이마티콘을 이마트앱 구매/선물이 아닌 다른 경로(캡처본 또는 이미지로 전달 받은 쿠폰)로 전달 받은 이마티콘(혹은 바코드)의 경우, 환불이 불가할 수 있습니다. (고객정보보호에 의거)",
          ]
        },
        {
          title:"Q2) 다른 사람에게 선물한 이마티콘을 환불 받을 수 있나요?",
          desc:`A2) 이마티콘은 보내시는 분께서 받으시는 분에게 이미 선물하신 상품이므로, 실질적인 권리는 최종 수신자에게 있습니다. 따라서, 환불에 대한 권리 역시 이마티콘을 최종 소유한 수신자에게 있기 때문에 주문자는 환불을 받을 수가 없습니다.`
        },
        {
          title:"Q3) 유효기간이 있는 이마티콘의 유효기간 만료시 환불은 어떻게 하나요?",
          desc:`A3) 충전형 이마티콘 구매/선물시에는 유효기간이 별도로 존재하지 않습니다.
          다만, 경품 또는 사은품의 목적으로 제공된 이마티콘의 경우 환불이 불가합니다.`
        },
        {
          title:"Q4) 구매 후 주문 취소가 가능한가요?",
          desc:`A4) 구매한 미사용 이마티콘은 [이마트앱 > 이마티콘 > 카드보관함> 취소 카드 선택] 에서 구매 취소하실 수 있습니다. 카드사 취소의 경우 카드사 사정에 따라 취소요청 후 결제취소가 확정되기까지 3~7일 정도 소요될 수 있습니다.(다만 1년이상 미사용카드 취소시에는 현금 환불 진행) 취소 금액은 결제하신 신용카드 요금 청구 시 차감 청구 되며, 청구서 발송 이후에 취소하실 경우 익월 차감 청구 됩니다. 자세한 사항은 결제대행 PG사(TOSS) 및 사용하신 카드사 홈페이지를 참고하시기 바랍니다.
          계좌 이체건의 취소의 경우 PG대행사(TOSS)측 이용기준에 결제하신 계좌로 입금 되시니 참고하시기 바랍니다`
        },
        {
          title:"Q5) 사은품으로 받은 이마티콘도 환불 할수 있나요?",
          desc:`A5) 경품 또는 사은품의 목적으로 제공된 이마티콘의 경우 환불이 불가합니다.
          또한 별도의 유효기간이 있으니 해당 유효기간 안에 사용하시기 바랍니다. (유효기간 이후 사용 및 환불 불가)`
        },
      ],
      currentIndex: 0,
      tabTitle: ''
    }
  },
  mounted() {
    this.$heading('자주하는 질문');
    this.setInit();
  },
  methods: {
    handlerAccordino(e) {
      const currentTarget = e.currentTarget;
      const grayTextbox = document.querySelectorAll('.gray-text-wrap');
      grayTextbox.forEach((item, index) => {
        Number(currentTarget.dataset.index) === index ? item.classList.toggle('on') : item.classList.remove('on');
        item.className.includes('on') ? currentTarget.children[1].className = "icon-small-top-arrow" : item.previousSibling.children[1].className = "icon-small-bottom-arrow";
        item.className.includes('on') ? currentTarget.children[1].title = "상세내용 닫기" : item.previousSibling.children[1].title = "상세내용 열기";
      })

      const aTag = document.getElementsByTagName('a'); //웹접근성
      Array.from(aTag).forEach((item) => {
          item.title = '상세내용 열기';
      })
      if(currentTarget.children[1].className == "icon-small-top-arrow") currentTarget.getElementsByTagName('a')[0].title = '상세내용 닫기';
    },
    handlerMenuClick(e) {
      const li = document.querySelectorAll('.question-item');
      li.forEach((item) => { //웹접근성 조치
        item.classList.remove('active');
        item.ariaSelected = false;
      });
      e.currentTarget.classList.add('active');
      e.currentTarget.ariaSelected = true;
      this.tabTitle = e.currentTarget.textContent;
      this.currentIndex = Number(e.currentTarget.dataset.index);
      this.setAccordion();
    },
    setInit() {
      const li = document.querySelectorAll('.question-item');
      li[0].classList.add('active');
      li[0].ariaSelected = true; //웹접근성 조치
      this.tabTitle = li[0].textContent;
      this.dataList = this.useList;
    },
    setAccordion() {
      switch(this.currentIndex) {
        case 0 : this.dataList = this.useList
          break;
        case 1 : this.dataList = this.payList
          break;
        case 2 : this. dataList = this.chargingList
          break;
        case 3 : this. dataList = this.sendList
          break;
        case 4 : this. dataList = this.cancelList
          break;
        default: this.dataList = [];
      }
      const grayTextbox = document.querySelectorAll('.gray-text-wrap');
      grayTextbox.forEach((item) => {
        item.classList.remove('on');
        item.previousSibling.children[1].className = "icon-small-bottom-arrow"
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/home/emarticonQuestions.scss';
</style>

